// extracted by extract-css-chunks-webpack-plugin
module.exports = {"secondImage":"secondImage_JqPFV","fade":"fade_SCHk6","fade-in-animation":"fade-in-animation_c5dZ8"};